import { Component, Input, OnInit } from '@angular/core';
import { AssetImageConfiguration } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';

import { ActiveCampaignLeadMagnet } from '@generated/graphql';
import { LazyAssetComponent } from '../../../lazy-image/components/lazy-asset/lazy-asset.component';

@Component({
    selector: 'app-lead-magnet-widget',
    templateUrl: './lead-magnet-widget.component.html',
    imports: [LazyAssetComponent],
})
export class LeadMagnetWidgetComponent implements OnInit {
    @Input() entry: ActiveCampaignLeadMagnet;
    imageConfiguration: AssetImageConfiguration;
    featuredImageConfiguration: AssetImageConfiguration;

    constructor() {}

    ngOnInit(): void {
        this.imageConfiguration = {
            image: this.entry?.image,
            ratioWidth: 1,
            ratioHeight: 1,
            width: 400,
            width2x: 800,
        };
        this.featuredImageConfiguration = {
            image: this.entry?.featuredImage,
            ratioWidth: 1,
            ratioHeight: 1,
            width: 600,
            width2x: 800,
        };
    }
}
